import React, {useRef, useState } from 'react';
import Container from 'container';
import Headline from 'headline';
import Button from 'button';
import { debouncedNavigation } from '../../../utility';
import s from './visit.module.scss';

const data = {
  links: [
    {
      name: 'HOME',
      link: '/',
    },
    {
      name: 'ABOUT',
      link: '/about',
    },
    {
      name: 'FAQ',
      link: '/faq',
    },
    {
      name: 'BLOG',
      link: '/blog',
    },
    {
      name: 'VISIT',
      link: '/visit',
    },
    {
      name: 'PRIVATE EVENTS',
      link: '/private-events',
    },
  ],
};

export default function VisitCannabition({setModalOn, isSafari}) {
  const contact = useRef(null);

  const [touchStart, setTouchStart] = useState(0);

  const handleTouchUp = (event) => {
    const position = event.changedTouches[0].clientY;
    if (position > touchStart && contact.current.scrollTop === 0) {
      debouncedNavigation('#exhibits');
    }
  };

  const handleTouchStart = (event) => {
    setTouchStart(event.changedTouches[0].clientY);
  };

  const visitWheeling = (event) => {
    const direction = event.deltaY < 0 ? 'up' : 'down';
    if (direction === 'up' && contact.current.scrollTop === 0) {
      debouncedNavigation('#exhibits');
    }
  };

  return (
    <Container onTouchStart={handleTouchStart} onTouchMove={handleTouchUp} ref={contact} className={`${s.root} ${isSafari ? s.safari : ''}`} onWheel={visitWheeling}>
      <Headline h1 className={s.headline}>
        Temporarily Closed <br></br>
       <p>We are moving to a new Location</p>
      </Headline>
      <div
      style={{
        marginTop:'40vh'
      }}
      className={s.footer}>
        <ul className={s.Linklist}>
          {data.links.map(({ name, link }) => (
            <li className={s.linkItem} key={name}>
              <a href={link}>{name}</a>
            </li>
          ))}
        </ul>
        <p className={s.footerText}>
          ©2019 Cannabition LLC, All Rights Reserved.
        </p>
      </div>
    </Container>
  );
}
